export default "__VITE_ASSET__e6990dbb__"